var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExosomeBioBoost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35600_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#A0CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5323 20.4746L26.7916 17.7339L9.25098 35.2745L11.9917 38.0152L29.5323 20.4746Z",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5322 20.4707L26.7915 17.73L23.3252 21.1963L26.0659 23.937L29.5322 20.4707Z",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9492 7.15332V11.1757",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7344 13.3726H31.7528",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5605 8.95166L32.4117 11.7989",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3697 8.95166L35.5225 11.7989",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9492 7.15332V11.1757",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7344 13.3726H31.7528",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5605 8.95166L32.4117 11.7989",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1805 13.3922L36.1582 13.3765",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 19.5834L33.9533 15.561",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3656 17.7692L35.5303 14.9102",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9418 14.4843C34.5952 14.4843 35.1249 13.9546 35.1249 13.3012C35.1249 12.6478 34.5952 12.1182 33.9418 12.1182C33.2885 12.1182 32.7588 12.6478 32.7588 13.3012C32.7588 13.9546 33.2885 14.4843 33.9418 14.4843Z",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2158 19.0549L33.1491 14.1729",
    stroke: "#1B2C58",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35600_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExosomeBioBoost);
export default __webpack_public_path__ + "static/media/exosome-bio-boost.5783bef88a24e0d81f6181ac2d461a55.svg";
export { ForwardRef as ReactComponent };